'use client';
import type { ReactElement } from 'react';
import type { MotionValue } from 'framer-motion';
import { Prism, type PrismFpsSample } from '@/components/ui/Prism';
import { useModalStack } from '@/contexts/layout';
import { useBodyScrollLocked } from '@/hooks/dom/use-body-scroll-lock';
import { STATIC_HERO_BACKGROUND_STYLE, type HeroBackgroundPrismConfig, } from './Cherobackground.constants';
import { PrismBackgroundMode } from './usePrismHealthGate';
interface CherobackgroundPrismLayerProps {
    backgroundMode: PrismBackgroundMode;
    glow: MotionValue<number>;
    onPrismError: (error: unknown) => void;
    onPrismFpsSample: (sample: PrismFpsSample) => void;
    prismConfig: HeroBackgroundPrismConfig;
    scale: MotionValue<number>;
}
export function CherobackgroundPrismLayer({ backgroundMode, glow, onPrismError, onPrismFpsSample, prismConfig, scale, }: CherobackgroundPrismLayerProps): ReactElement {
    const bodyScrollLocked = useBodyScrollLocked();
    const { stack: modalStack } = useModalStack();
    const pageCovered = bodyScrollLocked || modalStack.length > 0;
    if (backgroundMode === PrismBackgroundMode.Static) {
        return <div data-el="Cherobackground/PrismLayer/StaticSurface" style={STATIC_HERO_BACKGROUND_STYLE}/>;
    }
    return (<Prism paused={pageCovered} animationType={prismConfig.animationType} timeScale={prismConfig.timeScale} height={prismConfig.height} baseWidth={prismConfig.baseWidth} scale={scale} hueShift={prismConfig.hueShift} colorFrequency={prismConfig.colorFrequency} noise={prismConfig.noise} glow={glow} maxDpr={prismConfig.maxDpr} onError={onPrismError} onFpsSample={onPrismFpsSample}/>);
}
